'use client';

import { useEffect } from 'react';

export default function TerminalLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  // Hide root layout chrome (AppHeader, Footer, PaymentWarningBanner) for full-screen terminal
  useEffect(() => {
    document.body.classList.add('terminal-active');
    return () => {
      document.body.classList.remove('terminal-active');
    };
  }, []);

  return (
    <div className="terminal-view" style={{ position: 'fixed', inset: 0, zIndex: 100 }}>
      {children}
    </div>
  );
}
